import { Box, Paper, Typography } from "@mui/material";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import HubOutlinedIcon from "@mui/icons-material/HubOutlined";
import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";
import MedicationOutlinedIcon from "@mui/icons-material/MedicationOutlined";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import PsychologyOutlinedIcon from "@mui/icons-material/PsychologyOutlined";

const steps = [
  {
    icon: <PersonOutlineOutlinedIcon sx={{ fontSize: 28, color: "#FF8904" }} />,
    title: "Médico recebe o paciente",
    subtitle: "Clínica ou consultório",
  },
  {
    icon: <ChatBubbleOutlineIcon sx={{ fontSize: 28, color: "#FF8904" }} />,
    title: "Faz uma pergunta clínica",
    subtitle: "Em linguagem natural",
  },
  {
    icon: <HubOutlinedIcon sx={{ fontSize: 28, color: "#FF8904" }} />,
    title: "8 agentes são ativados",
    subtitle: "Simultaneamente",
  },
  {
    icon: <ScienceOutlinedIcon sx={{ fontSize: 28, color: "#FF8904" }} />,
    title: "Literatura científica",
    subtitle: "18k+ artigos",
  },
  {
    icon: <MedicationOutlinedIcon sx={{ fontSize: 28, color: "#FF8904" }} />,
    title: "Protocolos clínicos",
    subtitle: "Protocolos e diretrizes clínicas",
  },
  {
    icon: <ShieldOutlinedIcon sx={{ fontSize: 28, color: "#FF8904" }} />,
    title: "Segurança verificada",
    subtitle: "Interações e alertas",
  },
  {
    icon: <FactCheckOutlinedIcon sx={{ fontSize: 28, color: "#FF8904" }} />,
    title: "Resposta organizada",
    subtitle: "Em segundos",
  },
  {
    icon: <PsychologyOutlinedIcon sx={{ fontSize: 28, color: "#FF8904" }} />,
    title: "Médico decide com segurança",
    subtitle: "Baseado em evidências",
  },
];

export default function HowItWorksSection() {
  return (
    <section id="como-funciona" className="relative z-10 px-6 md:px-12 pb-20 md:pb-28">
      <div className="text-center mb-14">
        <Typography
          variant="h4"
          sx={{
            color: "#ffffff",
            fontWeight: 700,
            fontFamily: "Oxanium, sans-serif",
            letterSpacing: "-0.02em",
            marginBottom: "12px",
            fontSize: { xs: "1.5rem", md: "2rem" },
          }}
        >
          Como o Dr. Weedy trabalha
        </Typography>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 max-w-6xl mx-auto">
        {steps.map((step, index) => (
          <Paper
            key={step.title}
            elevation={0}
            sx={{
              background:
                "linear-gradient(135deg, rgba(26, 49, 60, 0.6) 0%, rgba(4, 9, 10, 0.8) 100%)",
              backdropFilter: "blur(16px)",
              border: "1px solid rgba(255,255,255,0.08)",
              borderRadius: "24px",
              padding: "20px",
              transition: "all 0.3s ease",
              "&:hover": {
                border: "1px solid rgba(255, 137, 4, 0.25)",
                transform: "translateY(-4px)",
                boxShadow: "0 12px 40px rgba(0,0,0,0.3)",
              },
            }}
          >
            <Box
              sx={{
                width: "28px",
                height: "28px",
                borderRadius: "50%",
                background: "linear-gradient(135deg, #FF8904 0%, #E7000B 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "14px",
                boxShadow: "0 4px 12px rgba(255, 137, 4, 0.4)",
              }}
            >
              <Typography
                sx={{ color: "#ffffff", fontWeight: 700, fontSize: "0.8rem" }}
              >
                {index + 1}
              </Typography>
            </Box>
            <Box sx={{ marginBottom: "10px" }}>{step.icon}</Box>
            <Typography
              sx={{
                color: "#ffffff",
                fontWeight: 700,
                fontSize: "1rem",
                fontFamily: "Oxanium, sans-serif",
                marginBottom: "4px",
              }}
            >
              {step.title}
            </Typography>
            <Typography
              sx={{
                color: "rgba(255,255,255,0.6)",
                fontSize: "0.85rem",
                lineHeight: 1.5,
              }}
            >
              {step.subtitle}
            </Typography>
          </Paper>
        ))}
      </div>
    </section>
  );
}
